function getPreparedProducts(products) {
    let tmp = [];
    let prepared = [];

    products.forEach(function(item) {
        const count = tmp[item.wpid] ? tmp[item.wpid].quantity + 1 : 1;
        const variant = item.duration.value ? item.duration.value + item.duration.append : 'n/a';
        tmp[item.wpid] = {
            name: item.title,
            id: item.wpid,
            price: item.price.value,
            category: item.category,
            variant: variant,
            quantity: count,
        };
    });


    tmp.forEach(function(item) {
        prepared.push(item);
    });

    return prepared;
}

window.dataLayer = window.dataLayer || [];

const GtmHelper = {
    addToCart: function(service) {
        const variant = service.duration.value ? service.duration.value + service.duration.append : 'n/a';

        window.dataLayer.push({
            'event': 'addToCart',
            'ecommerce': {
                'add': {
                    'products':[
                        {
                            'name': service.title,
                            'id': service.id,
                            'price': service.price.value,
                            'category': service.category,
                            'variant': variant,
                            'quantity': 1,
                        },
                    ],
                },
            },
        });
    },

    viewBookings: function(products) {
        window.dataLayer.push({
            'event': 'viewBookings',
            'ecommerce': {
                'checkout': {
                    'actionField': {'step': 1},
                    'products': getPreparedProducts(products),
                },
            },
        });
    },

    makeAppointment: function(products) {
        const option = 'do not subscribe';

        window.dataLayer.push({
            'event': 'makeAppointment',
            'ecommerce': {
                'checkout': {
                    'actionField': {'step': 2, 'option': option},
                    'products': getPreparedProducts(products),
                },
            },
        });
    },

    confirmBooking: function(products, total, transId) {
        window.dataLayer.push({
            'event': 'confirmBooking',
            'ecommerce': {
                'purchase': {
                    'actionField': {
                        'id': transId, // Transaction ID.
                        'affiliation': 'Online Store',
                        'revenue': total, // Total transaction value (incl. tax and shipping)
                        'tax': '0', // can make this zero if no applicable
                        'shipping': '0',
                    },
                    'products': getPreparedProducts(products),
                },
            },
        });
    },

    addGiftVoucher: function(voucher) {
        if (voucher.id == '-1') {
            voucher.title = '€' + voucher.price + ' Gift Voucher';
        }

        window.dataLayer.push({
            'event': 'addToCart',
            'ecommerce': {
                 'add': {
                    'products':[
                        {
                            'name': 'Gift Voucher',
                            'id': voucher.id === -1 ? 'v' + voucher.id : voucher.id,
                            'price': voucher.fee + voucher.price,
                            'category': 'Gift Voucher',
                            'variant': voucher.title,
                            'quantity': 1,
                        },
                    ],
                },
            },
        });
    },

    checkoutGiftVoucher: function(voucher) {

        if (voucher.id == '-1') {
            voucher.title = '€' + voucher.price + ' Gift Voucher';
        }

        window.dataLayer.push({
            'event': 'checkoutGiftVoucher',
            'ecommerce': {
                 'checkout': {
                    'actionField': {'step': 1},
                    'products':[
                        {
                            'name': 'Gift Voucher',
                            'id': voucher.id === -1 ? 'v' + voucher.id : voucher.id,
                            'price': voucher.fee + voucher.price,
                            'category': 'Gift Voucher',
                            'variant': voucher.title,
                            'quantity': 1,
                        },
                    ],
                },
            },
        });
    },

    payGiftVoucher: function(voucher, card) {
        if (voucher.id == '-1') {
            voucher.title = '€' + voucher.price + ' Gift Voucher';
        }

        window.dataLayer.push({
            'event': 'payGiftVoucher',
            'ecommerce': {
                 'checkout': {
                    'actionField': {
                        'step': 2,
                        'option': card,
                    },
                    'products':[
                        {
                            'name': 'Gift Voucher',
                            'id': voucher.id === -1 ? 'v' + voucher.id : voucher.id,
                            'price': voucher.fee + voucher.price,
                            'category': 'Gift Voucher',
                            'variant': voucher.title,
                            'quantity': 1,
                        },
                    ],
                },
            },
        });
    },

    confirmGiftVoucher: function(voucher, transId) {
        if (voucher.id == '-1') {
            voucher.title = '€' + voucher.price + ' Gift Voucher';
        }

        window.dataLayer.push({
            'event': 'confirmGiftVoucherPurchase',
            'ecommerce': {
                'purchase': {
                    'actionField': {
                        'id': transId,
                        'affiliation': 'Stripe',
                        'revenue': voucher.fee + voucher.price,
                        'tax':'0',
                    },
                    'products':[{
                        'name': 'Gift Voucher',
                        'id': voucher.id === -1 ? 'v' + voucher.id : voucher.id,
                        'price': voucher.fee + voucher.price,
                        'category': 'Gift Voucher',
                        'variant': voucher.title,
                        'quantity': 1,
                    }],
                },
            },
        });
    },
};

export default GtmHelper;



// WEBPACK FOOTER //
// ./scripts/util/GtmHelper.js